































































































import {
  Component,
  Vue,
  Prop,
  Provide,
  Watch
} from "vue-property-decorator";
import { namespace } from "vuex-class";
import ValidationService from "../../../services/validation.service";
import container from "../../../inversify.config";
import { IContentTemplate } from "../../../models/interfaces/content/content-template.model.interface";
import { ContentTemplateModel } from "../../../models/content/content-template.model";
import { ICampaignDeliveryType } from "../../../models/interfaces/campaign/campaign-delivery-type.model.interface";

const ContentTypeModule = namespace("contentTypeModule");
const ContentTemplateModule = namespace("contentTemplateModule");
const ContentSetVersionModule = namespace("contentSetVersionModule");
const ContentScenarioTypeModule = namespace("contentScenarioTypeModule");
const CampaignDeliveryTypeModule = namespace("campaignDeliveryTypeModule");

@Component({
  components: {}
})
export default class ContentTemplateEditor extends Vue {
  @ContentTypeModule.Action public retrieveContentTypes;
  @ContentTypeModule.Getter public contentTypes;
  @ContentScenarioTypeModule.Action public retrieveContentScenarioTypes;
  @ContentScenarioTypeModule.Getter public contentScenarioTypes;
  @CampaignDeliveryTypeModule.Action public retrieveCampaignDeliveryTypes;
  @CampaignDeliveryTypeModule.Getter public campaignDeliveryTypes: ICampaignDeliveryType[];
  @ContentTemplateModule.Action public retrieveTemplate;
  @ContentSetVersionModule.Action public createTemplate;
  @ContentTemplateModule.Action public updateTemplate;
  @ContentTemplateModule.Getter public template;

  get headerText(): string {
    if (this.readonly) {
      return "Content Template Viewer";
    }
    return this.liveTemplate
      ? "Content template Editor - Warning, this template is in production"
      : "Content template Editor";
  }

  get headerVariant(): string {
    return this.liveTemplate && !this.readonly ? "warning" : "";
  }

  @Provide() public options = [];
  @Provide() public scenarioOptions = [];
  @Provide() public campaignDeliveryTypeOptions: ICampaignDeliveryType[] = [];
  @Provide() public templateModel: IContentTemplate = new ContentTemplateModel();

  @Prop() public show: boolean;
  @Prop() public templateId: number = 0;
  @Prop() public readonly: boolean;

  private liveTemplate: boolean = false;

  public checkStatus() {
    this.liveTemplate = this.templateModel.state.statusType === 2;
  }

  @Watch("show", { deep: true })
  public onTemplateUpdate() {
    if (this.templateId > 0) {
      this.retrieveTemplate(this.templateId).then((result) => {
        this.templateModel = this.template;
        this.checkStatus();
      });
    } else {
      this.templateModel = new ContentTemplateModel();
      this.checkStatus();
    }
  }

  public hideDeleteModal() {
    this.$emit("changeTemplateModalState", false);
  }

  public getValidationClass(fieldName: string) {
    return container
      .get<ValidationService>(ValidationService)
      .getValidationClass(this.$validator, fieldName);
  }

  public populateTemplateTypeOptions() {
    this.retrieveContentTypes()
    .then(() => {
      this.options = this.contentTypes.map((val) => ({
        value: val.contentTypeId,
        text: val.name
      }));
    });
  }

  public populateContentScenarioTypeOptions() {
    this.retrieveContentScenarioTypes()
    .then(() => {
      this.scenarioOptions = this.contentScenarioTypes.map((val) => ({
        value: val.contentScenarioTypeId,
        text: val.name
      }));
    });
  }

  public populateCampaignDeliveryTypeOptions() {
    this.retrieveCampaignDeliveryTypes()
    .then(() => {
      this.campaignDeliveryTypeOptions = this.campaignDeliveryTypes;
    });
  }

  public created() {
    this.populateTemplateTypeOptions();
    this.populateContentScenarioTypeOptions();
    this.populateCampaignDeliveryTypeOptions();
  }

  private submitForm() {
    this.$validator.validateAll().then((valid) => {
      if (valid) {
        if (this.templateId > 0) {
          this.updateTemplate(this.templateModel).then((value) => {
            if (value) {
              this.hideDeleteModal();
            }
          });
        } else {
          this.createTemplate(this.templateModel).then((value) => {
            if (value) {
              this.hideDeleteModal();
            }
          });
        }
      }
    });
  }
}
